import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-cancel-confirmation-dialog',
  templateUrl: './cancel-confirmation-dialog.component.html',
  styleUrls: ['./cancel-confirmation-dialog.component.scss']
})
export class CancelConfirmationDialogComponent implements OnInit {
  dataType: any;
  dataName: any;
  firstStep: boolean = true;
  secondStep: boolean = false;
  clickToConfirm: boolean = false;
  clickToConfirmError: boolean =  false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<CancelConfirmationDialogComponent>) {
      this.dataName = data.dataName;
      this.dataType = data.dataType;
  }

  ngOnInit() {
  }
  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    console.log(this.clickToConfirm);
    if (this.clickToConfirm) {
      this.clickToConfirmError =  false;
      this.firstStep = false;
      this.secondStep = true;
    } else {
        this.clickToConfirmError = true;
    }
  }

  confirmDelete() {
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cancel-confirmation-dialog/cancel-confirmation-dialog.component.ts